import React from 'react'
import TableCellCheckbox from './TableCellCheckbox'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import {
  Select
} from '../../../Functions/Table'
import {
  SELECTED_COMPTABILITE
} from '../../../Redux/Actions/Comptabilite'

const TableCellCheckboxComptabilite = ({ item }) => {
  const dispatch = useDispatch()
  const selected = useSelector(state => state.comptabilite.selected)
  return (
    <TableCellCheckbox
      checked={selected.includes(item.id)}
      onClick={() => Select(dispatch, SELECTED_COMPTABILITE, selected, item.id)}
    />
  )
}

export default TableCellCheckboxComptabilite
